import ConnectionSpeed from './ConnectionSpeed';
export default ConnectionSpeed;
